import React from "react";
import { Tags, KeyRound, Handshake } from "lucide-react";
import { useRevealGroup } from "../../hooks/useReveal";

const ITEMS = [
  {
    numeral: "I",
    icon: Tags,
    title: "List With Us",
    body: "Unlock the right buyer for your asset through our curated network of qualified HNI and institutional clients.",
  },
  {
    numeral: "II",
    icon: KeyRound,
    title: "Buy With Us",
    body: "Gain access to the finest inventory in NCR — including off-market properties never listed on public platforms.",
  },
  {
    numeral: "III",
    icon: Handshake,
    title: "Sell With Us",
    body: "Strategic pricing, professional presentation, and the trust of a brand that has delivered for 18 years.",
  },
];

const ListSellBuy = () => {
  const ref = useRevealGroup(".reveal");
  return (
    <section ref={ref} className="bg-grain py-24 lg:py-28" data-testid="list-sell-buy">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-num-gold/30 border border-num-gold/30">
          {ITEMS.map(({ numeral, icon: Icon, title, body }, i) => (
            <div
              key={title}
              className={`reveal delay-${i + 1} relative bg-num-linen p-10 lg:p-14 overflow-hidden group`}
              data-testid={`lsb-item-${i}`}
            >
              <span
                aria-hidden
                className="absolute -top-6 -right-2 font-display font-medium text-num-forest leading-none select-none pointer-events-none"
                style={{ fontSize: "clamp(140px, 14vw, 200px)", opacity: 0.08 }}
              >
                {numeral}
              </span>
              <span className="absolute top-0 left-0 right-0 h-px bg-num-gold/70" />
              <Icon size={26} strokeWidth={1.2} className="text-num-gold relative" />
              <h3 className="font-display font-medium text-num-forest mt-6 relative" style={{ fontSize: "26px" }}>
                {title}
              </h3>
              <p className="font-body text-[14px] leading-[1.85] mt-4 max-w-[320px] relative" style={{ color: "#5e5443" }}>
                {body}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-px bg-num-deep py-5 px-6 text-center">
          <span className="font-ui text-[10px] uppercase track-label text-num-gold">
            We Deal in All Asset Classes · All Ticket Sizes · Residential · Commercial · Land ·
            Farmhouse · Plots · International
          </span>
        </div>
      </div>
    </section>
  );
};

export default ListSellBuy;
